/**
 * Additional Options (name, password, hostname, checkboxes)
 * Geist-styled section for the order form.
 *
 * @param {{
 *  formData: any,
 *  setFormData: Function,
 *  hostnameEdited: boolean,
 *  setHostnameEdited: Function,
 *  applications: Array<any>,
 *  distributions: Array<any>,
 * }} props
 */
import React from "react";
import { computeDefaultHostname } from "./orderUtils";

const OrderOptionsSection = ({
  formData,
  setFormData,
  setHostnameEdited,
  applications,
  distributions,
}) => {
  return (
    <div className="config-panel">
      <div className="panel-header">
        <p className="geist-desc">Configure additional settings for your VPS</p>
      </div>
      <div className="geist-field-stack">
        <label className="geist-label">VPS Name *</label>
        <input
          type="text"
          className="geist-input"
          value={formData.name}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, name: e.target.value }))
          }
          placeholder="my-cloud-vps"
          required
          maxLength={50}
        />
      </div>
      {/* Password field removed – portal will set/reset passwords after creation. */}
      {/* Hostname */}
      <div className="geist-field-stack mt-3 mb-3">
        <label className="geist-label">Hostname</label>
        <input
          type="text"
          className="geist-input"
          value={formData.hostname || ""}
          onChange={(e) => {
            setHostnameEdited(true);
            setFormData((prev) => ({ ...prev, hostname: e.target.value }));
          }}
          placeholder={computeDefaultHostname({
            formData,
            applications,
            distributions,
          })}
          maxLength={62}
        />
        <div className="geist-note mt-2">
          Edit the server hostname (required by some OSs to match DNS,
          screenshots, etc.)
        </div>
      </div>
      {/* Field stack: checkboxes */}
      <div className="geist-field-stack">
        <label className="geist-checkbox-label">
          <input
            type="checkbox"
            className="geist-checkbox"
            checked={formData.backups}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, backups: e.target.checked }))
            }
          />
          <span className="geist-checkbox-text">Enable Backups</span>
        </label>
        <div className="geist-checkbox-desc">
          Automatic backups of your cloud vps (+20% cost)
        </div>
        <label className="geist-checkbox-label mt-2">
          <input
            type="checkbox"
            className="geist-checkbox"
            checked={formData.monitoring}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, monitoring: e.target.checked }))
            }
          />
          <span className="geist-checkbox-text">Enable Monitoring</span>
        </label>
        <div className="geist-checkbox-desc">Real-time metrics and alerts</div>
      </div>
    </div>
  );
};

export default OrderOptionsSection;
